import { CloseOutlineIcon } from '@carboncopyco/icons';
import { TextSectionHeader } from '../Typography';

export interface HeaderProps {
  onClose?: () => void;
  title?: string;
}

export const Header = ({ onClose, title = '' }: HeaderProps) => (
  <div className="pb-5 flex justify-between items-center">
    <TextSectionHeader label={title} />
    <div
      onClick={onClose}
      className="h-full flex justify-between items-center"
    >
      <CloseOutlineIcon />
    </div>
  </div>
);
